import * as React from "react";
import { format } from "date-fns";
import { CalendarIcon, XIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useSearchParams } from "react-router-dom";
import { useSearchStore } from "@/stores/SearchStore";

export default function DateFilterPicker({
  className,
  urlName,
  future,
  selectedFilter,
  setSelectedFilter,
  ...props
}) {
  const [date, setDate] = React.useState();
  const [searchParams, setSearchParams] = useSearchParams();

  React.useEffect(() => {
    if (selectedFilter && date) {
      searchParams.delete(urlName);
      setDate(null);
      return;
    }

    // Get the deadline from the URL
    const filterParam = searchParams.get(urlName);

    if (!filterParam && date) {
      setDate(null);
    }

    const deadlineValue = parseInt(filterParam);

    if (deadlineValue) {
      setDate(deadlineValue * 1000);
    }
  }, [date, selectedFilter, searchParams, urlName]);

  function setAllSearchParams() {
    setSearchParams(searchParams);
    useSearchStore.setState({ searchPageSearchParams: searchParams });
  }

  function onClicked(inputDate) {
    if (inputDate) {
      try {
        const timestamp = Math.floor(inputDate / 1000);
        setSelectedFilter(null);
        searchParams.set(urlName, timestamp);
        setDate(inputDate);
      } catch (e) {}
    } else {
      searchParams.delete(urlName);
      setDate(null);
    }
    setAllSearchParams();
  }
  return (
    <div>
      <Popover>
        <PopoverTrigger asChild {...props}>
          <Button
            variant={"ghost"}
            className={cn(
              "justify-start text-left font-normal",
              !date && "text-muted-foreground",
              className
            )}
          >
            <CalendarIcon />
            <span>Custom date</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={date}
            onSelect={onClicked}
            disabled={(date) =>
              future ? date < new Date() : date > new Date()
            }
            initialFocus
          />
        </PopoverContent>
      </Popover>
      {date && (
        <Button className="mt-2" onClick={() => onClicked(null)}>
          <XIcon className="" /> {format(date, "PPP")}{" "}
        </Button>
      )}
    </div>
  );
}
